export default __webpack_public_path__ + "static/media/HDTX_Pengumuman RUPS 2024.06357b49.pdf";